import styled from "styled-components";

const ChildrenContent = styled.div<any>`
  ${({StylesContent}) => StylesContent};
`;

export default ChildrenContent;